/** @jsx jsx */
import { css } from '@emotion/react';

export const commonStyles = {
  hint: css`
    color: var(--cds-color-neutral-primary-weak);
    font-size: 12px;
    line-height: 18px;
    margin-top: 8px;
  `,
  emailInputReadOnly: css`
    .cds-input-readOnly {
      background-color: var(--cds-color-emphasis-primary-background-weak) !important;
    }

    .cds-input-readOnly .cds-inputAdornment-root {
      background-color: var(--cds-color-white-0);
      padding: 0 var(--cds-spacing-50);
    }
  `,
};
